import { useQuery } from "@tanstack/react-query";

import { DOMAIN_AUTH } from "../domain";

export const ACTION_VALIDATE_RESET_TOKEN = "VALIDATE_RESET_TOKEN";

interface ValidateResetTokenResponse {
  valid: boolean;
}

const validateResetToken = async (
  token: string,
): Promise<ValidateResetTokenResponse> => {
  const response = await fetch(
    `${import.meta.env.VITE_API_BASE_URL}/validate-reset-token`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    },
  );

  if (!response.ok) {
    throw new Error("Invalid or expired token");
  }

  return response.json();
};

interface UseValidateResetTokenOptions {
  token: string | null;
}

export const useValidateResetToken = ({
  token,
}: UseValidateResetTokenOptions): {
  isValidationPending: boolean;
  isTokenValid: boolean;
  isError: boolean;
} => {
  const { data, isPending, isError } = useQuery({
    queryKey: [DOMAIN_AUTH, ACTION_VALIDATE_RESET_TOKEN, token],
    queryFn: () => validateResetToken(token!),
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return {
    isValidationPending: !!token && isPending,
    isTokenValid: data?.valid ?? false,
    isError,
  };
};
